import cn from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';

const colors = {
  black: 'black',
  white: 'white',
  red: 'red',
  slate: 'slate',
  greenDark: 'green-dark',
  grey: 'grey'
};

const themes = {
  h1: 'h1',
  h2: 'h2',
  h2Hero: 'h2-hero',
  h3: 'h3',
  h3Portal: 'h3-portal',
  h3PortalBold: 'h3-portal-bold',
  h4: 'h4',
  h5: 'h5',
  h6: 'h6',
  inherit: 'inherit'
};

const allowedTags = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'div'];

const Heading = ({ as, children, className, level, color, theme, ...rest }) => {
  if (!children) {
    // Prevent empty semantic/text container elements
    return null;
  }

  const Tag = as || `h${level}`;

  return React.createElement(
    Tag,
    {
      className: cn(
        'heading',
        {
          [`heading--color-${color}`]: Boolean(color),
          [`heading--${theme}`]: Boolean(theme)
        },
        className
      ),
      ...rest
    },
    children
  );
};

Heading.propTypes = {
  as: PropTypes.oneOf(allowedTags),
  children: PropTypes.node,
  className: PropTypes.string,
  level: PropTypes.oneOf([1, 2, 3, 4, 5, 6]),
  color: PropTypes.oneOf(Object.values(colors)),
  theme: PropTypes.oneOf(Object.values(themes))
};

Heading.defaultProps = {
  as: undefined,
  level: 2,
  children: null,
  className: undefined,
  color: undefined,
  theme: undefined
};

Heading.propTypesMeta = {
  level: 'exclude',
  color: 'exclude',
  theme: 'exclude'
};

Heading.colors = colors;
Heading.themes = themes;

export default Heading;
